/**
 * Resolves once `prev` and `request` have both settled, to undefined, so a chain of in-flight join
 * claims holds no responses however many beats it has seen.
 */
export function afterSettled(prev: Promise<void>, request: Promise<unknown>): Promise<void> {
  return Promise.all([prev, request.catch(() => undefined)]).then(() => undefined)
}
